<template>
  <div class="py-3" v-html="basic_data_text_format"></div>
</template>

<script>
export default {
  props: {
    data: { type: String, required: true },
  },

  computed: {
    basic_data_text_format() {
      var basic_data_text = this.data

      if (basic_data_text.includes(":")) {
        basic_data_text = this.data.replace(/[;]/g, "<br />")
      }

      return basic_data_text
    },
  },
}
</script>

<style>
/* .v-btn {
  font-size: 11px !important;
} */
</style>
